module.exports = __webpack_public_path__ + "img/banner-bg1.b5d3cd50.jpg";